import { useIntl } from 'react-intl';
import { Severity } from '@tink/core/src/components/atoms/Icons/AlertIcon';
import { PageView } from '../../../models/analytics';
import { Provider, ProviderEntity } from '../../../models/provider';
import { commonMessages } from '../../atoms/CommonMessages/messages';
import { messages as providerDisabledMessages } from '../ProviderTemporaryDisabled/messages';
import { VerboseErrorScreen } from '../VerboseErrorScreen/VerboseErrorScreen';
import { useUrlQuery as useUrlQueryImport } from '../../ApplicationProviders/UrlQueryProvider/UrlQueryProvider';
import { messages } from './messages';

export type ProviderHealthStatusProps = {
  onClose: () => void;
  redirectHome: () => void;
  redirectBackToClient: () => void;
  provider: ProviderEntity;
  useUrlQuery?: () => { providerName: string | undefined };
};

export const UnhealthyProvider = ({
  provider,
  onClose,
  redirectHome,
  redirectBackToClient,
  useUrlQuery = useUrlQueryImport,
}: ProviderHealthStatusProps) => {
  const { providerName: isProviderPreselected } = useUrlQuery();
  const { formatMessage } = useIntl();

  const bodyText = isProviderPreselected
    ? formatMessage(messages.degradedBodyPreselectedProvider, {
        providerDisplayName: provider.displayName,
      })
    : formatMessage(messages.degradedBody, {
        providerDisplayName: provider.displayName,
      });

  if (Provider.isPlannedMaintenance(provider)) {
    return (
      <VerboseErrorScreen
        severity={Severity.WARNING}
        viewEvent={PageView.PROVIDER_HEALTH_STATUS_SCREEN}
        title={formatMessage(messages.plannedMaintenanceTitle, {
          providerDisplayName: provider.displayName,
        })}
        body={[{ text: bodyText }]}
        primaryAction={onClose}
        primaryButtonText={formatMessage(messages.tryAnyway)}
        secondaryAction={isProviderPreselected ? redirectBackToClient : redirectHome}
        secondaryButtonText={
          isProviderPreselected
            ? formatMessage(commonMessages.cancel)
            : formatMessage(providerDisabledMessages.selectAnother)
        }
      />
    );
  }

  return (
    <VerboseErrorScreen
      severity={Severity.WARNING}
      viewEvent={PageView.PROVIDER_HEALTH_STATUS_SCREEN}
      title={formatMessage(messages.degradedTitle, { providerDisplayName: provider.displayName })}
      body={[{ text: bodyText }]}
      primaryAction={onClose}
      primaryButtonText={formatMessage(messages.continueAnyway)}
      secondaryAction={isProviderPreselected ? redirectBackToClient : redirectHome}
      secondaryButtonText={
        isProviderPreselected
          ? formatMessage(commonMessages.cancel)
          : formatMessage(providerDisabledMessages.selectAnother)
      }
    />
  );
};
